import { Link } from "react-router-dom";

const products = [
  {
    title: "Bancony Server",
    pill: "The bridge",
    lede:
      "The supported, hardened server that lets AI agents access your bank's data and do things in your bank, safely and in a standard way. Your engineers don't have to build the plumbing.",
    highlights: [
      {
        title: "Plug AI agents into your bank",
        text: "Balances, transactions, payments, and other everyday banking actions become things an AI agent can call, through one standard interface.",
      },
      {
        title: "Bank-grade controls, by default",
        text: "Strict per-customer scopes, full audit trail, and protections against the new threats AI agents bring. Your CISO is on board because the controls were designed for this.",
      },
      {
        title: "Deploy where you need to",
        text: "On-prem, in your own cloud, or as a managed service we run for you. Same product, you pick the perimeter.",
      },
    ],
    link: "/server",
  },
  {
    title: "Bancony Assistant",
    pill: "The experience",
    lede:
      "A ready-made AI assistant that lives inside your bank's app and helps your customers manage their money. Branded for your bank, integrated with your existing identity, live in weeks.",
    highlights: [
      {
        title: "From idea to live pilot in weeks",
        text: "A four-week internal pilot is realistic for most banks. Customer launch typically follows in another month or two.",
      },
      {
        title: "Real banking UI, not chat bubbles",
        text: "Account snapshots, transfer previews, transaction confirmations. All rendered natively in your channel, in your design system.",
      },
      {
        title: "Drop into web and mobile",
        text: "Iframe for web, WebView for mobile. Your customer's session passes straight through, with no new login and no new auth perimeter.",
      },
    ],
    link: "/assistant",
  },
];

const Card = ({ p }) => (
  <div className="product-card">
    <div className="product-card-header">
      <h3 className="product-card-title">{p.title}</h3>
      <span className="product-card-pill">{p.pill}</span>
    </div>
    <p className="product-card-lede">{p.lede}</p>
    <ul className="product-card-highlights">
      {p.highlights.map((h) => (
        <li key={h.title}>
          <strong>{h.title}</strong>
          <span>{h.text}</span>
        </li>
      ))}
    </ul>
    <Link to={p.link} className="btn-arrow product-card-link">
      More about {p.title}
    </Link>
  </div>
);

export const TwoProductOverview = () => (
  <section className="section soft" id="products">
    <div className="section-inner">
      <span className="section-eyebrow">Our two products</span>
      <h2>How it actually works.</h2>
      <p className="lede">
        Bancony Server is the bridge between your bank and AI agents. Bancony Assistant
        is one AI experience that uses that bridge. Take both. Or take just the Server
        and build your own experience. Or take just the Assistant and run it against your
        own bank2ai-compliant server, or one from another vendor.
      </p>

      <div className="two-product-grid">
        {products.map((p) => <Card key={p.title} p={p} />)}
      </div>
    </div>
  </section>
);
